import type { InferQueryResult } from '~/alumni/easyVerein.api';

export const EVENT_CUSTOM_FIELD_IDS = {
  image: 283090980,
};

export const MEMBER_CUSTOM_FIELD_IDS = {
  graduationYear: 283705458,
  fieldOfStudy: 283705472,
  occupation: 283705489,
  employer: 283705491,
  linkedIn: 283705564,
  whatsAppOptIn: 448822710,
};

export function getCustomFieldValue<T = string>(
  customFields: InferQueryResult<{ id: any; value: any; customField: { id: any } }>[],
  fieldId: number,
) {
  return customFields?.find((f) => f.customField?.id === fieldId)?.value as T | undefined;
}

export function getMemberImageUrl(_profilePicture: string) {
  if (!_profilePicture || _profilePicture.includes('defaultUserImage')) {
    return '/alumni/default-profile-image.svg';
  }

  return _profilePicture
    ? `/api/alumni/profile-picture?imageName=${encodeURIComponent(_profilePicture)}`
    : undefined;
}
